import '../../../styles/Stand/Documents.css';

import React                   from 'react';
import { observer }            from 'mobx-react';
import { Card }                from 'antd';
import { Button }              from 'antd';
import { FileTextOutlined }    from '@ant-design/icons';
import { DownloadOutlined }    from '@ant-design/icons';
import StandMediaModel         from 'models/StandMediaModel';
import { appStore }            from 'stores/AppStore';
import { standDashboardStore } from 'stores/index';
import { downloadFileFromUrl } from 'utils/downloadFile';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

const styleIcon = {
  fontSize: '22px',
  marginRight: 6,
};

class StandDashboardDocumentsBox extends React.Component {
  public render() {
    const documentsFiltered = this._getDocumentsFiltered();

    return (
      <Card
        className="accented-shadow"
        title={
          <div style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flex: 1 }}>
              <FileTextOutlined style={{ ...styleIcon }} />
              <span>
                <FormattedMessageWrapper id="Mes attestations" />
              </span>
            </div>
          </div>
        }
      >
        {documentsFiltered.length < 1 ? (
          <div>
            <FormattedMessageWrapper id="Aucun document" />
          </div>
        ) : (
          <ul className="documents-list">
            {documentsFiltered.map((document: StandMediaModel) => (
              <li key={document.id}>
                <div>
                  <b>{document.mediaFileName}</b>
                </div>
                <div>
                  <Button
                    htmlType="button"
                    icon={<DownloadOutlined />}
                    onClick={() => this._openDocument(document)}
                    style={{
                      alignItems: 'center',
                      display: 'flex',
                      gap: '8px',
                    }}
                  >
                    <FormattedMessageWrapper id="Télécharger" />
                  </Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    );
  }

  private _getDocumentsFiltered = () => {
    const { collDocument } = standDashboardStore;
    return collDocument.filter((doc: StandMediaModel) => doc.language === appStore.locale);
  };

  private _openDocument = (media: StandMediaModel) => {
    const filename = media.mediaFileName || 'download';
    downloadFileFromUrl(media.objectUrl, filename);
  };
}

const StandDashboardDocumentsBoxObserver = observer(StandDashboardDocumentsBox);

export default StandDashboardDocumentsBoxObserver;
